'use client';

import { Box, Divider, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import TabPanel from '@/components/TabPanel';
import { PDPEvents } from '@/misc/event-enums';
const PDPIntroduction = dynamic(async () => (await import('./PDPIntroduction')).default, {
  ssr: true
});
const PDPEvaluation = dynamic(async () => (await import('./PDPEvaluation')).default, {
  ssr: true
});
const PDPDocuments = dynamic(async () => (await import('./PDPDocuments')).default, {
  ssr: true
});
const PDPProgressReport = dynamic(async () => (await import('./PDPProgressReport')).default, {
  ssr: true
});
const PDPPhases = dynamic(async () => (await import('./PDPPhases')).default, {
  ssr: true
});
export default function PDPTabs() {
  const tabs = [{
    key: 0,
    title: ' معرفی طرح',
    eventKey: PDPEvents.Intro
  }, {
    key: 1,
    title: 'ارزیابی زیما',
    eventKey: PDPEvents.ZeemaAssess
  }, {
    key: 2,
    title: 'مدارک و مستندات',
    eventKey: PDPEvents.Documents
  }, {
    key: 3,
    title: 'زمان‌بندی طرح',
    eventKey: PDPEvents.Timing
  }, {
    key: 4,
    title: 'گزارش پیشرفت',
    eventKey: PDPEvents.AdvancedReporting
  }];
  const [tab, setTab] = useState(tabs[0].key);
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(+newValue);
  };
  return <Box sx={{
    bgcolor: 'background.bg',
    borderRadius: {
      md: 'var(--corner_radius_m)'
    },
    px: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_m_nudge)'
    },
    py: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_m_nudge)'
    },
    width: '100%'
  }} data-sentry-element="Box" data-sentry-component="PDPTabs" data-sentry-source-file="PDPTabs.tsx">
      <Tabs value={tab} variant='scrollable' onChange={handleTabChange} textColor='primary' indicatorColor='primary' aria-label='pdp tabs' data-sentry-element="Tabs" data-sentry-source-file="PDPTabs.tsx">
        {tabs.map(tabItem => <Tab key={'pdp_tabs_' + tabItem.key} value={tabItem.key} label={tabItem.title} data-gtm-button-id={tabItem.eventKey} />)}
      </Tabs>
      <Divider data-sentry-element="Divider" data-sentry-source-file="PDPTabs.tsx" />
      <TabPanel index={0} value={tab} data-sentry-element="TabPanel" data-sentry-source-file="PDPTabs.tsx">
        <PDPIntroduction data-sentry-element="PDPIntroduction" data-sentry-source-file="PDPTabs.tsx" />
      </TabPanel>
      <TabPanel index={1} value={tab} data-sentry-element="TabPanel" data-sentry-source-file="PDPTabs.tsx">
        <PDPEvaluation data-sentry-element="PDPEvaluation" data-sentry-source-file="PDPTabs.tsx" />
      </TabPanel>
      <TabPanel index={2} value={tab} data-sentry-element="TabPanel" data-sentry-source-file="PDPTabs.tsx">
        <PDPDocuments data-sentry-element="PDPDocuments" data-sentry-source-file="PDPTabs.tsx" />
      </TabPanel>
      <TabPanel index={3} value={tab} data-sentry-element="TabPanel" data-sentry-source-file="PDPTabs.tsx">
        <PDPPhases data-sentry-element="PDPPhases" data-sentry-source-file="PDPTabs.tsx" />
      </TabPanel>
      <TabPanel index={4} value={tab} data-sentry-element="TabPanel" data-sentry-source-file="PDPTabs.tsx">
        <PDPProgressReport data-sentry-element="PDPProgressReport" data-sentry-source-file="PDPTabs.tsx" />
      </TabPanel>
    </Box>;
}